// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const ForYou: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-OverviewOverview" */ './ForYou/ForYou.tsx'))
			.ForYou,
});

export const Recent: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RecentRecent" */ './Recent/Recent.tsx')).Recent,
});

export const Starred: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-StarredStarred" */ './Starred/Starred.tsx'))
			.Starred,
});

export const Drafts: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DraftsDrafts" */ './Drafts/Drafts.tsx')).Drafts,
});

export const Tasks: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TasksTasks" */ './Tasks/Tasks.tsx')).Tasks,
});

export { Error } from './Error.tsx';
